<section class="AisAlx-login-wrapper">
  <div class="login-container">
    <!-- Main Login Card -->
    <div class="login-card">
      <!-- Formulario de acceso -->
      <div class="login-form-section">
        <!-- Logo and Branding -->
        <div class="brand-section">
          <h1 class="brand-name" aria-label="A2 Hacienda">
            <span class="brand-monogram" aria-hidden="true">A<span class="brand-number">2</span></span>
            <span class="brand-wordmark" aria-hidden="true">Hacienda</span>
          </h1>
        </div>
        <!-- Login Form -->
        <div class="form-wrapper">
          <div class="form-header">
            <h2 class="form-title">Bienvenido</h2>
            <p class="form-subtitle">Ingresa tus credenciales para acceder</p>
          </div>

          <form class="login-form" (ngSubmit)="login()" novalidate>
            <!-- Username Input -->
            <div class="input-group">
              <label for="username" class="input-label">Usuario</label>
              <div class="input-wrapper">
                <i class="input-icon bi bi-person"></i>
                <input type="text"
                  id="username"
                  class="form-input"
                  placeholder="Ingresa tu usuario"
                  [(ngModel)]="loginRequest.nombreUsuario"
                  name="username"
                  autocomplete="username">
              </div>
            </div>

            <!-- Password Input -->
            <div class="input-group">
              <label for="password" class="input-label">Contraseña</label>
              <div class="input-wrapper">
                <i class="input-icon bi bi-lock"></i>
                <input type="password"
                  id="password"
                  class="form-input"
                  placeholder="Ingresa tu contraseña"
                  [(ngModel)]="loginRequest.contrasena"
                  name="password"
                  autocomplete="current-password">
              </div>
            </div>

            <!-- Login Button -->
            <button type="submit"
              class="login-btn"
              [disabled]="!loginRequest.nombreUsuario || !loginRequest.contrasena">
              <span class="btn-text">Iniciar Sesión</span>
              <i class="btn-icon bi bi-arrow-right"></i>
            </button>
          </form>
        </div>
      </div>

    </div>

    <!-- Footer -->
    <div class="login-footer">
      <div class="footer-content">
        <div class="footer-left">
          <span class="company-link">A2 Hacienda</span>
          <span class="copyright">© 2026 Todos los derechos reservados</span>
        </div>
      </div>
    </div>
  </div>
</section>
